import moment from "moment";
import { ApiMessage } from "src/api/types";
import Avatar from "src/components/Avatar";
import MessageBidForm from "src/components/chat/MessageBidForm";
import MessageFile from "src/components/chat/MessageFile";
import Skeleton from "src/components/Skeleton";
import useAuth from "src/hooks/selectors/useAuth";
import useWindowSize from "src/hooks/useWindowSize";

const Message = ({
	content,
	is_me,
	created_at,
	is_admin,
	creator,
	media,
	type: messageType,
	data,
}: ApiMessage) => {
	const auth = useAuth();
	const { type } = auth;
	const size = useWindowSize();

	let className = "items-end flex";
	if (type === "company") {
		className += " text-white  ";
	} else {
		className += " ";
	}

	if (is_me) {
		className += " rounded-md w-max ml-auto";
	}

	if (is_admin) {
		className += " justify-center items-center text-center";
	}

	return (
		<div className={`${className} w-full gap-4`}>
			{!is_me && !is_admin && !size.isPhone && (
				<Avatar size="regular" src={creator?.avatar} />
			)}
			<div className="">
				{media && media.length > 0 ? (
					<div className="flex flex-wrap md:flex-row flex-col mb-4 gap-4">
						{media.map((file) => (
							<MessageFile key={`file-${file.id}`} media={file} />
						))}
					</div>
				) : (
					false
				)}
				{content && (
					<div
						className={`${
							is_me
								? "bg-primary text-white ml-auto"
								: "bg-gray text-dark"
						} p-4 rounded-md w-max`}
					>
						<div className="max-w-[220px] md:max-w-[400px] w-full description">
							{content}
						</div>
					</div>
				)}
				{messageType === "bid" && data && (
					<MessageBidForm {...{ creator }} bid={data.bid} />
				)}

				<small
					className={`text-dark opacity-20 ${
						is_me && "w-full block text-right mt-1"
					}`}
				>
					{moment(created_at).format("DD-MM-YYYY HH:mm")}
				</small>
			</div>
			{is_me && !is_admin && !size.isPhone && (
				<Avatar size="regular" src={creator?.avatar} />
			)}
		</div>
	);
};

interface LoadingProps {
	is_me?: boolean;
	lines?: number;
}

const Loading = ({ is_me, lines }: LoadingProps) => {
	const size = useWindowSize();
	let className = "items-end flex";

	if (is_me) {
		className += " rounded-md w-max ml-auto";
	}

	return (
		<div className={`${className} w-full gap-4`}>
			{!is_me && !size.isPhone && <Skeleton className="w-12 h-12" />}
			<div
				className={`${
					is_me ? "bg-primary ml-auto" : "bg-gray-900"
				} p-4 rounded-md w-max`}
			>
				<div className="flex flex-col gap-2 max-w-[220px] md:max-w-[400px] w-full description">
					{new Array(lines || 3).fill("").map((_, index) => (
						<Skeleton
							key={`${Math.random()}-${index}`}
							className="h-[27px]"
							style={{
								width: index === 0 ? "54px" : "200px",
							}}
						/>
					))}
				</div>
			</div>
			{is_me && !size.isPhone && <Skeleton className="w-12 h-12" />}
		</div>
	);
};

Message.Loading = Loading;

export default Message;
